<template>
  <Head title="Депозит" />
  <div>Пожалуйста ознакомьтесь с правилами работы депозитов ниже, затем
    <a href="#" style="color: indigo" onclick="window.Telegram.WebApp.close()">
    закройте</a> это окно и следуйте инструкциям в чате бота. Внесение средств подразумевает
  согласие с описанными ниже условиями депозитов.</div>
  <div><br/><br/></div>

  <textarea style="width: 90%; height: 70vh; margin-left: 10px">
    Условия использования депозитов.

    Депозит вносится либо переводом на карту диспетчера, либо по согласованию с диспетчером передаётся наличными водителю. После поступления депозита на счёт диспетчера или водителя (наличкой) в рабочие часы диспетчер вносит в программу данные и уведомляет пассажира что депозит принят. Депозит возможно пополнять на любую сумму по согласованию с диспетчером, но не менее 450 рублей (эквивалент одной поездки)
При бронировании поездки приоритет отдаётся элитным пассажирам, купившим билет, либо внёсшим депозит.

    Элитная группа пассажиров:
    1) Получает возможность выбора места в авто.
    2) Может занять место в поездке другого пассажира, который выразил желание, но не приобрёл билет либо не внёс депозит.
    Пассажир, внёсший депозит, приравнивается в правах к пассажиру, купившему билет.
    Пассажиры не купившие билеты и без депозита, забронировавшие место в поездке через программу или другим способом, попадают в список пассажиров, желающих поехать в выбранное время в указанном направлении. Их место может быть продано Элитным пассажирам, желающим купить билет на поездку или в случае наличия на их счете депозита.
    Депозит в размере 450 рублей даёт право забронировать одно место в поездке из Самары в Тольятти или обратно. Размер депозита не зависит от размера скидок, предоставляемых пассажиру, места, забронированного в поездке, а также места сбора и высадки пассажиров.

    Поездка из Самары в Тольятти или обратно для пассажиров с депозитом равна 450 рублей, это минимальная сумма.

    Поездка из Самары в Тольятти или обратно для пассажиров БЕЗ ДЕПОЗИТА равна 500 рублей, это минимальная сумма.

    Правила аннулирования депозита:

    Депозит является гарантией поездки, забронированной пассажиром, и аннулируется автоматически в случае отказа пассажира от поездки менее, чем за 150 минут до начала поездки, либо отказа от ранних поездок (начинающихся с 4:00 до 8:30) накануне поездки после 20:30.
    Это означает, что сумма депозита будет списана за поездку, если пассажир не поехал или отменил поездку на условиях, указанных выше.

    Правила возврата суммы депозита:

    Депозит не предназначается оплаты поездки и может быть внесен минимум на две недели.
    По истечении двух недель пассажир может вернуть депозит. Возврат депозита  осуществлятся в течении трёх рабочих дней после обращения к диспетчеру, но не ранее чем через две недели после внесения. Также по истечении двух недель депозит можно использовать для расчёта за поездку. Для этого он должен отправить в Вайбере, Телеграмме или СМС сообщение диспетчеру с указанием, за какую именно поездку необходимо списать депозит (дата, время, направление). Диспетчер в этом случае делает скриншот, отправляет его в переписку с пассажиром и делает в поездке отметку о том, что она оплачена за счет депозита. В случае, если стоимость этой поездки окажется больше размера депозита, пассажир обязан доплатить разницу. Если стоимость поездки будет меньше размера депозита, разница не возвращается.
  </textarea>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
//
export default {

  mounted() {
    //setTimeout(() => window.Telegram.WebApp.close(), 7000)
  },

  components: {
    Head,
  },
}
</script>
